/* eslint-disable import/prefer-default-export */
import * as Sentry from "@sentry/react";
import HowToGuide from "../apiResources/HowToGuide";
import { LOAD_HOW_TO_GUIDES, LOAD_HOW_TO_GUIDES_ERROR } from "./types";

export const loadHowToGuides = () => async (dispatch) => {
  try {
    const guides = await HowToGuide.all();

    dispatch({
      type: LOAD_HOW_TO_GUIDES,
      payload: guides.data,
    });
  } catch (error) {
    Sentry.captureException(error);

    dispatch({
      type: LOAD_HOW_TO_GUIDES_ERROR,
      payload: error,
    });
  }
};
